<template>
  <div class="w-100p position-relative mt-3">


    <table class="dynamictable center no-footer w300">
      <thead>
        <tr>
          <th>Dátum a čas merania</th>
          <th>Hodnota (<span v-html="velicina"></span>)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in getDataForTable">
          <td>{{ item.dt | moment("DD.MM.YYYY HH:mm") }}</td>
          <td :class="getClass(item)">{{ showValue(item) }}</td>
        </tr>
      </tbody>
    </table>

    <div class="clearfix"></div>
  </div>
</template>

<script>

import shmuMixin from "../mixin";

export default {
  components: {
  },
  name: 'KoPollutantsSubTable',
  props: [
    'loadedData',
    'loadedDataExtra',
    'selectedPollutantId',
  ],
  mixins: [
    shmuMixin,
  ],
  data() {
    return {
      velicina : '&micro;g/m<sup>3</sup>',
    }
  },
  watch: {
  },

  mounted() {

  },
  computed: {
    getDataForTable() {
      const self = this;
      const sp = self.selectedPollutantId;
      const ld = self.loadedData;
      let pollutantData = this.loadedData.filter(obj => {
        return obj.pollutant_id === self.selectedPollutantId;
      });

      if (this.selectedPollutantId === 't85026') {
        this.velicina = 'ng/m<sup>3</sup>';
      } else {
        this.velicina = '&micro;g/m<sup>3</sup>';
      }

      if (pollutantData && pollutantData.length > 0) {
        pollutantData.sort((a, b) => (b.dt - a.dt));
        return pollutantData.slice(0,24);
      }

      return [];

    }


  },
  methods: {
    getClass(item) {
      if (typeof item.limit_level !== "undefined" && item.limit_level !== null) {
        if (item.value === null) return '';
        return 'woko_' + item.limit_level;
      }
      return '';
    },
    showValue(item) {
      if (item.value === null) return '*';
      return item.value;
    }
  },



}
</script>


<style lang="scss">

</style>
